// Accordion Toggles

class Accordion {
  constructor() {
    this.accordions = [].slice.call(
      document.querySelectorAll('.accordion__title')
    );

    this.accordions.forEach(accordion => {
      ['click', 'keypress'].forEach(event => {
        accordion.addEventListener(event, e => {
          const key = e.which || e.keyCode;
          if (key === 13 || e.type === 'click') {
            const parent = accordion.parentNode;
            parent.classList.toggle('open');

            if (!e.target.parentElement.classList.contains('open')) {
              e.target.classList.add(parent.dataset.cc);
            } else {
              e.target.classList.remove(parent.dataset.cc);
            }
          }
        });
      });
    });
  }
}

const accordionInit = {
  init() {
    // if element exists init this class
    const accordionElem = [].slice.call(
      document.querySelectorAll('.accordion')
    );
    if (accordionElem.length > 0) {
      new Accordion();
    }
  },
};

export default accordionInit;
